import styled from "styled-components";

interface LegendItemProps {
  $ledColor?: "red" | "yellow" | "green" | "gray";
  $legendType?: "led" | "status";
}

export const LegendItem = styled.li<LegendItemProps>`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const LedBox = styled.div<LegendItemProps>`
  width: 6px;
  height: 6px;
  background: ${(props) => props.theme.colors[props.$ledColor + "Status"]};
  border-radius: 3px;
`;

export const LegendTit = styled.div`
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.2rem;
  font-weight: 500;
`;

export const LegendIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const LegendValue = styled.div`
  color: ${(props) => props.theme.colors.primary100};
  font-size: 1.2rem;
`;
